export const ACTIVITY_EVENT_MESSAGE = {
  DOCUMENT_CREATED: () => `Created document`,
  DOCUMENT_OPENED: () => `Opened document`,
  DOCUMENT_SENT_FOR_REVIEW: subjects =>
    Array.isArray(subjects) && subjects.length > 0
      ? `Shared document with ${subjects
          .map(subject => subject.name)
          .join(", ")}`
      : `Shared document with someone`,
  DOCUMENT_SENT_FOR_ESIGN: subjects =>
    Array.isArray(subjects) && subjects.length > 0
      ? `Sent document for eSign to ${subjects
          .map(subject => subject.name)
          .join(", ")}`
      : `sent document for eSign`,
  DOCUMENT_REVIEWED: () => `opened document`,
  DOCUMENT_SENT_FOR_ACCEPT: subjects =>
    Array.isArray(subjects) && subjects.length > 0
      ? `sent document for acceptance to ${subjects
          .map(subject => subject.name)
          .join(", ")}`
      : `sent document for acceptance`,

  DOCUMENT_ACCEPTOR_ACCEPTED: () => `Document accepted`,
  DOCUMENT_ACCEPTOR_REJECTED: () => `Document rejected`,
  DOCUMENT_ESIGN_DECLINED: () => `Declined to sign document`,
  DOCUMENT_ESIGN_ACCEPTED: () => `eSigned document`,

  // Reviewer email
  REVIEWER_EMAIL_BOUNCED: () => `Email sent for document sharing bounced `,

  // Esign related event text
  ESIGN_EMAIL_DELIVERED: () => `Received email and document for eSign `,
  ESIGN_EMAIL_BOUNCED: () => `Email with eSign request bounced`,
  ACCEPTANCE_EMAIL_OPENED: () => `Opened email for document acceptance `,
  ESIGN_EMAIL_OPENED: () => `Opened email for eSign request `,
  DOCUMENT_ALL_ESIGN_ACCEPTED: () => `Received all eSignatures `,
  ACCEPTANCE_EMAIL_DELIVERED: () =>
    `Received email and document for acceptance `,
  ACCEPTANCE_EMAIL_BOUNCED: subjects =>
    Array.isArray(subjects) && subjects.length > 0
      ? `Email with acceptance  request to ${subjects
          .map(subject => subject.name)
          .join(", ")} bounced `
      : `Email with acceptance request has bounced`,
  DOCUMENT_ALL_ACCEPTOR_ACCEPTED: () => `Received acceptance from everyone `,
};

export const ACTIVITY_EVENTS = {
  DOCUMENT_CREATED: "DOCUMENT_CREATED",
  DOCUMENT_OPENED: "DOCUMENT_OPENED",
  DOCUMENT_SENT_FOR_REVIEW: "DOCUMENT_SENT_FOR_REVIEW",
  DOCUMENT_SENT_FOR_ESIGN: "DOCUMENT_SENT_FOR_ESIGN",
  DOCUMENT_REVIEWED: "DOCUMENT_REVIEWED",
  DOCUMENT_SENT_FOR_ACCEPT: "DOCUMENT_SENT_FOR_ACCEPT",
  DOCUMENT_ACCEPTOR_ACCEPTED: "DOCUMENT_ACCEPTOR_ACCEPTED",
  DOCUMENT_ACCEPTOR_REJECTED: "DOCUMENT_ACCEPTOR_REJECTED",
  DOCUMENT_ESIGN_DECLINED: "DOCUMENT_ESIGN_DECLINED",
  DOCUMENT_ESIGN_ACCEPTED: "DOCUMENT_ESIGN_ACCEPTED",

  // Acceptance and Reject related events
  REVIEWER_EMAIL_BOUNCED: "REVIEWER_EMAIL_BOUNCED",
  ACCEPTANCE_EMAIL_DELIVERED: "ACCEPTANCE_EMAIL_DELIVERED",
  ACCEPTANCE_EMAIL_BOUNCED: "ACCEPTANCE_EMAIL_BOUNCED",
  ACCEPTANCE_EMAIL_OPENED: "ACCEPTANCE_EMAIL_OPENED",
  DOCUMENT_ALL_ACCEPTOR_ACCEPTED: "DOCUMENT_ALL_ACCEPTOR_ACCEPTED",

  // Esign related events
  ESIGN_EMAIL_DELIVERED: "ESIGN_EMAIL_DELIVERED",
  ESIGN_EMAIL_OPENED: "ESIGN_EMAIL_OPENED",
  ESIGN_EMAIL_BOUNCED: "ESIGN_EMAIL_BOUNCED",
  ESIGN_EMAIL_CLICKED: "ESIGN_EMAIL_CLICKED",
  DOCUMENT_ALL_ESIGN_ACCEPTED: "DOCUMENT_ALL_ESIGN_ACCEPTED",
};



// WEBPACK FOOTER //
// ./src/constants/activities.js